import { CommonUIService } from 'src/app/sections/common/services/common.ui.service';
import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { Bank } from '../../../models/bank/bank-model';
import { UntypedFormBuilder, UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { BankService } from '../services/bank.service';

import { TranslateService } from '@ngx-translate/core';
import { Town } from '../../../models/doctor/doctor-town.model';
import { AuxillaryService } from '../../common/services/auxillary.service';
import { AuthService } from '../../auth/services/auth.service';
import { CurrencyPipe } from '@angular/common';
import { SortList } from '../../common/sortList';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-bank-details',
  templateUrl: './add-bank-details.component.html',
  styleUrls: ['./add-bank-details.component.scss']
})
export class AddBankDetailsComponent implements OnInit {
  @ViewChild('modalLargeNew', { static: false }) child;
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() locale: string = 'es';
  @Input() isHidePersonalBankDetails: boolean = false;

  bank: Bank;
  submitted = false;
  bankForm: FormGroup;
  isEdit: boolean;
  isLoading = false;
  public searchTown = '';
  townList: Town[];
  loggedUserId = 0;
  isBalanceEditable: boolean;
  townId: number;
  countryId: number;
  provinceId: number;
  isFocus = false;
  isNotNumber = false;
  formatBalance = '';
  townControl = new UntypedFormControl();

  validationMessages = {
    iban: {
      minLength: "ibanLengthValidate",
      maxLength: "ibanLengthValidate",
      pattern: "AlphabetsandNumbersOnly",
    },
    entity: {
      minLength: "entityLengthValidate",
      maxLength: "entityLengthValidate",
      pattern: "digitValidate",
    },
    office: {
      minLength: "officeLengthValidate",
      maxLength: "officeLengthValidate",
      pattern: "digitValidate",
    },
    dc: {
      minLength: "dcLengthValidate",
      maxLength: "dcLengthValidate",
      pattern: "digitValidate",
    },
    account: {
      minLength: "accountLengthValidate",
      maxLength: "accountLengthValidate",
      pattern: "digitValidate",
    },
    swift: {
      minLength: "swiftMinLengthValidate",
      maxLength: "swiftMaxLengthValidate",
      pattern: "digitValidate",
    },
    telephone1: {
      pattern: "digitValidate",
    },
    telephone2: {
      pattern: "digitValidate",
    },
    mobileNumber: {
      pattern: "digitValidate",
    },
    fax: {
      pattern: "digitValidate",
    },
    email: {
      email: "invalidEmailAddress",
    },
    web: {
      pattern: "invalidEmailAddress",
    },
  }

  constructor(private formBuilder: UntypedFormBuilder, private bankService: BankService, private toastService: ToastrService,
    private translationService: TranslateService, private auxillaryService: AuxillaryService,
    private authService: AuthService, private currencypipe: CurrencyPipe, private commonUIService: CommonUIService) {
    this.bank = new Bank();
    this.townList = [] as Town[];
    const userDetails = this.authService.getTokenData();
    if (userDetails) {
      this.loggedUserId = userDetails.userId;
    }
    this.isBalanceEditable = true;
    this.isNotNumber = false;
  }

  public show(bankData): void {
    this.submitted = false;
    this.bank = new Bank();
    this.isBalanceEditable = true;
    this.isNotNumber = false;
    if (bankData) {
      this.bank = bankData;
      this.searchTown = this.bank.town ? this.bank.town.townName : '';
      this.townId = this.bank.townId ? this.bank.townId : null;
      this.provinceId = this.bank.town ? this.bank.town.provinceId : null;
      this.countryId = this.bank.town ? this.bank.town.countryId : null;
      this.bank.town = this.bank.town ? this.bank.town : null;
      this.formatBalance = this.currencypipe.transform(this.bank.balance, 'EUR', 'symbol', '1.2-2', this.locale);
      if (this.bank.bankIncome.length != 0 || this.bank.bankExtraction.length != 0) {
        this.isBalanceEditable = false;
      }
    }
    this.bankForm.reset();
    this.checkIfEditOrAdd();
    this.child.show();
  }

  ngOnInit() {
    this.checkIfEditOrAdd();
    this.getTownList();
  }

  focus(value: any) {
    this.isNotNumber = false;
    if (value) {
      let bal = '';
      if (this.locale == 'es') {
        bal = value.replace('.', '');
      } else {
        bal = value.replace(',', '');
      }
      const vl = bal.replace(',', '.');
      const formatAmount = vl.replace('€', '');
      this.bankForm.controls.balance.setValue(formatAmount.trim());
    }
  }

  focusOut(value: any) {
    if (value) {
      const v = value.replace(',', '.');
      if (!isNaN(v)) {
        const formatvalue = this.currencypipe.transform(v, 'EUR', 'symbol', '1.2-2', this.locale);
        this.bankForm.controls.balance.setValue(formatvalue);
      } else {
        this.commonUIService.showValidationError('numberOnly');
        this.isNotNumber = true;
      }
    }
  }

  checkIfEditOrAdd() {
    if (!this.bank.id) {
      this.isEdit = false;
      this.initializeForAddBank();
      return;
    }
    this.isEdit = true;
    this.initializeForEditBank();
  }

  initializeForAddBank() {
    this.bankForm = this.formBuilder.group({
      id: [''],
      bankDescription: ['', [Validators.required]],
      iban: ['', [Validators.maxLength(4), Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9]*$')]],
      entity: ['', [Validators.maxLength(4), Validators.minLength(4), Validators.pattern('^[0-9]*$')]],
      office: ['', [Validators.maxLength(4), Validators.minLength(4), Validators.pattern('^[0-9]*$')]],
      dc: ['', [Validators.maxLength(2), Validators.minLength(2), Validators.pattern('^[0-9]*$')]],
      account: ['', [Validators.maxLength(10), Validators.minLength(10), Validators.pattern('^[0-9]*$')]],
      swift: ['', [Validators.maxLength(11), Validators.minLength(8), Validators.pattern('^[0-9]*$')]],
      address: [''],
      number: [''],
      door: [''],
      floorNumberOfBuilding: [''],
      postalCode: [''],
      townId: [''],
      provinceName: [''],
      countryName: [''],
      telephone1: ['', [Validators.pattern('^[0-9]*$')]],
      telephone2: ['', [Validators.pattern('^[0-9]*$')]],
      mobileNumber: ['', [Validators.pattern('^[0-9]*$')]],
      fax: ['', [Validators.pattern('^[0-9]*$')]],
      email: ['', [Validators.email]],
      web: ['', [Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      isActive: [''],
      balance: ['']
    });
    this.townControl.setValue(null);
  }

  initializeForEditBank() {
    this.bankForm = this.formBuilder.group({
      id: [this.bank.id],
      bankDescription: [this.bank.bankDescription, [Validators.required]],
      iban: [this.bank.iban, [Validators.maxLength(4), Validators.minLength(4), Validators.pattern('^[a-zA-Z0-9]*$')]],
      entity: [this.bank.entity, [Validators.maxLength(4), Validators.minLength(4), Validators.pattern('^[0-9]*$')]],
      office: [this.bank.office, [Validators.maxLength(4), Validators.minLength(4), Validators.pattern('^[0-9]*$')]],
      dc: [this.bank.dc, [Validators.maxLength(2), Validators.minLength(2), Validators.pattern('^[0-9]*$')]],
      account: [this.bank.account, [Validators.maxLength(10), Validators.minLength(10), Validators.pattern('^[0-9]*$')]],
      swift: [this.bank.swift, [Validators.maxLength(11), Validators.minLength(8), Validators.pattern('^[0-9]*$')]],
      address: [this.bank.address],
      number: [this.bank.number],
      door: [this.bank.door],
      floorNumberOfBuilding: [this.bank.floorNumberOfBuilding],
      postalCode: [this.bank.postalCode],
      townId: [this.searchTown],
      provinceName: [this.bank.town ? this.bank.town.province.provinceName : ''],
      countryName: [this.bank.town ? this.bank.town.country.countryName : ''],
      telephone1: [this.bank.telephone1, [Validators.pattern('^[0-9]*$')]],
      telephone2: [this.bank.telephone2, [Validators.pattern('^[0-9]*$')]],
      mobileNumber: [this.bank.mobileNumber, [Validators.pattern('^[0-9]*$')]],
      fax: [this.bank.fax, [Validators.pattern('^[0-9]*$')]],
      email: [this.bank.email, [Validators.email]],
      web: [this.bank.web, [Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      isActive: [this.bank.isActive],
      balance: [this.formatBalance ? this.formatBalance : '']
    });
    this.townControl.setValue(this.bank.town ? this.bank.town.townName : null);
  }

  searchTownByText(_$event) {
    this.bankForm.controls.countryName.setValue('');
    this.bankForm.controls.provinceName.setValue('');
    this.townId = null;
    this.countryId = null;
    this.provinceId = null;
  }


  onSave() {
    this.submitted = true;
    if (this.bankForm.controls.townId.value == 0) {
      this.bankForm.controls.townId.setValue(null);
    }
    if (!this.commonUIService.validateForm(this.bankForm, this.validationMessages)) {
      return;
    }
    this.bank = this.bankForm.value;
    if (this.bankForm.value.balance) {
      let value = '';
      if (this.locale == 'es') {
        value = this.bankForm.value.balance.replace('.', '');
      } else {
        value = this.bankForm.value.balance.replace(',', '');
      }
      const vl = value.replace(',', '.');
      const formatAmount = vl.replace('€', '');
      this.bankForm.value.balance = formatAmount.trim();
    }
    this.bank.balance = this.bankForm.value.balance;
    this.bank.townId = this.townId;
    this.bank.provinceId = this.provinceId;
    this.bank.countryId = this.countryId;
    this.bank.country = null;
    this.bank.province = null;
    this.bank.town = null;
    if (this.isEdit) {
      this.updateBank(this.bank);
      return;
    }
    this.saveBank(this.bank);
  }

  private returnResponse(response: any) {
    this.close.emit(response);
    this.child.hide();
    this.isLoading = false;
    this.clearData();
  }

  saveBank(bank: Bank) {
    bank.id = 0;
    bank.isActive = true;
    bank.entryDate = new Date();
    bank.enteredBy = this.loggedUserId;
    this.isLoading = true;
    this.bankService.saveBank(bank).subscribe(
      (data: any) => {
        this.successToast('saveBankSuccess');
        this.returnResponse(data._data);
      },
      (error) => {
        this.failToast(error._message);
        this.isLoading = false;
      }
    );
  }

  updateBank(bank: Bank) {
    bank.id = this.bank.id;
    bank.modifiedDate = new Date();
    bank.modifiedBy = this.loggedUserId;
    bank.enteredBy = this.bank.enteredBy;
    bank.entryDate = this.bank.entryDate;
    this.isLoading = true;
    this.bankService.updateBank(bank.id, bank).subscribe(
      (data: any) => {
        this.successToast('updateBankSuccess');
        this.returnResponse(data._data);
      },
      (error) => {
        this.failToast(error._message);
        this.isLoading = false;
      }
    );
  }

  clearData() {
    this.provinceId = null;
    this.townId = null;
    this.countryId = null;
  }

  getTownList() {
    this.auxillaryService.getTownList().subscribe(
      (data: any) => {
        this.townList = SortList(data._data, 'townName');
      },
      (error) => {
        this.failToast(error._message);
      }
    );
  }

  onSelectTown(result) {
    if (result) {
      this.searchTown = result.townName;
      if (result.id == 0) {
        this.bank.town = new Town();
        return;
      }
      this.townId = result.id;
      const town = this.townList.filter(x => x.id == this.townId)[0];
      this.bankForm.controls.countryName.setValue(town.country.countryName);
      this.bankForm.controls.provinceName.setValue(town.province.provinceName);
      this.countryId = town.countryId;
      this.provinceId = town.provinceId;
    }
  }

  isTownValueSelected(isValueSelected: any) {
    if (isValueSelected == 'empty') {
      this.bankForm.controls.townId.setValue(null);
    }
    //value recieved, form group and control name
    this.commonUIService.novasearchDropDownValidator(isValueSelected, this.bankForm, 'townId');
  }

  onClearTown() {
    this.townControl.setValue(null);
    this.bankForm.controls.townId.setValue(null);
    this.countryId = null;
    this.provinceId = null;
    this.townId = null;
    this.bankForm.controls.provinceName.setValue(null);
    this.bankForm.controls.countryName.setValue(null);
  }

  successToast(messageTranslationKey) {
    this.translationService.get(['success', messageTranslationKey]).subscribe((translations: any) => {
      this.toastService.success(translations[messageTranslationKey], translations.success, {
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        progressAnimation: 'increasing',
        positionClass: 'toast-bottom-right', // Adjust the position as needed
      });
    });
  }

  failToast(message) {
    this.translationService.get(['errorTitle', message]).subscribe((translations: any) => {
      this.toastService.error(translations[message], translations.success, {
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        progressAnimation: 'increasing',
        positionClass: 'toast-bottom-right', // Adjust the position as needed
      });
    });
  }
// Move to next input field on maxlength
  moveToNext(event: Event, nextField: HTMLInputElement) {
    const input = event.target as HTMLInputElement;
  
    if (input.value.length >= input.maxLength) {
      nextField.focus();
    }
  }
  
  get bankDescription() {
    return this.bankForm.get('bankDescription');
  }
  get iban() {
    return this.bankForm.get('iban');
  }
  get entity() {
    return this.bankForm.get('entity');
  }
  get office() {
    return this.bankForm.get('office');
  }
  get dc() {
    return this.bankForm.get('dc');
  }
  get account() {
    return this.bankForm.get('account');
  }
  get swift() {
    return this.bankForm.get('swift');
  }
  get telephone1() {
    return this.bankForm.get('telephone1');
  }
  get telephone2() {
    return this.bankForm.get('telephone2');
  }
  get mobileNumber() {
    return this.bankForm.get('mobileNumber');
  }
  get fax() {
    return this.bankForm.get('fax');
  }
  get email() {
    return this.bankForm.get('email');
  }
  get web() {
    return this.bankForm.get('web');
  }
  get townIdentity() {
    return this.bankForm.get('townId');
  }
  get address() {
    return this.bankForm.get('address');
  }
  get number() {
    return this.bankForm.get('number');
  }
  get door() {
    return this.bankForm.get('door');
  }
  get floorNumberOfBuilding() {
    return this.bankForm.get('floorNumberOfBuilding');
  }
  get postalCode() {
    return this.bankForm.get('postalCode');
  }
  get provinceName() {
    return this.bankForm.get('provinceName');
  }
  get countryName() {
    return this.bankForm.get('countryName');
  }
  get isActive() {
    return this.bankForm.get('isActive');
  }
  get balance() {
    return this.bankForm.get('balance');
  }

}
